import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexInline,
    ...common.middleText,
    ...common.fontWeight600,
    ...common.textGray900,
    alignItems: 'center',
    justifyContent: 'space-between',
    '&$big': {
      ...common.biggerText,
    },
  },
  gutter: {
    marginBottom: '1rem',
  },
  bar: {
    width: 4,
    height: 14,
    marginRight: 10,
    '$big &': {
      height: 20,
      marginRight: 15,
    },
    '$obsolete &': {
      backgroundColor: theme.palette.grey[500],
    },
    '$default &': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  big: {},
  normal: {},
  default: {},
  obsolete: {},
}));

export interface FormTitleProps {
  title: React.ReactNode;
  actions?: React.ReactNode;
  size?: 'big' | 'normal';
  variant?: 'default' | 'obsolete';
  gutter?: boolean;
}

export const FormTitle: React.FC<FormTitleProps> = (props) => {
  const { title, actions = null, size = 'normal', variant = 'default', gutter = true } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div
      className={clsx(classes.container, classes[size], classes[variant], gutter && classes.gutter)}
    >
      <div className={classes.bar} />
      {title}
      <div style={{ flex: 1 }} />
      {actions}
    </div>
  );
};
